export const DocumentStatus = {
  REGISTERED: 'Registered',
  UPLOADING: 'Uploading',
  UPLOADED: 'Uploaded',
  UPLOAD_FAILED: 'Upload Failed',
  VALIDATION_ERROR: 'Validation Error',
  APPLYING_OCR: 'Applying OCR',
  OCR_READY: 'OCR Ready',
  OCR_FAILED: 'OCR Failed',
  PREPROCESSING: 'Preprocessing',
  PREPROCESSING_COMPLETE: 'Preprocessing Complete',
  PREPROCESSING_FAILED: 'Preprocessing Failed',
  UNKNOWN_PIPELINE_ERROR: 'Unknown Pipeline Error',
  READY_FOR_GDPR_CHECK: 'Ready For GDPR Check',
  GDPR_CHECK_IN_PROGRESS: 'GDPR Check In Progress',
  READY_FOR_AI: 'Ready For AI',
  REMOVING_BREACH_PAGES: 'Removing Breach Pages',
  AI_PROCESSING_COMPLETE: 'AI Processing Complete',
};

export type DocumentStatus = (typeof DocumentStatus)[keyof typeof DocumentStatus];

// Case Page uses snake_case format for status field
export const CaseDocumentGdprStatus = {
  READY_FOR_GDPR_CHECK: 'READY_FOR_GDPR_CHECK',
  GDPR_CHECK_IN_PROGRESS: 'GDPR_CHECK_IN_PROGRESS',
} as const;

export type CaseDocumentGdprStatus = (typeof CaseDocumentGdprStatus)[keyof typeof CaseDocumentGdprStatus];
